import TechnologyAdvancedForm from './TechnologyAdvancedForm'

export default TechnologyAdvancedForm
